export default __webpack_public_path__ + "static/media/480_store04-en-web.a75d81c5.png";